<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <modal-header-default
    class="border"
    [options]="{
			headerTitleKey: null,
			headerTitle: null
		}">
    <a (click)="closeModal()" header-right>{{ "close" | translate }}</a>
  </modal-header-default>
  <div class="auto-staking-cancel-container">
    <svg-inline src="assets/images/auto-stake-cancel-icon.svg" class="cancel-icon" [class.invert]="darkModeService.darkModeEnabled" />
    <span class="title">
      {{ "auto_staking_cancel_title" | translate }}
    </span>
    <span class="subtitle">
      {{ "auto_staking_cancel_subtitle" | translate }}
    </span>
    <button
      (click)="cancelAutoStaking()"
      [disabled]="apiLoading"
      class="btn btn-primary btn-lg font-bold submit-btn cancel-button"
      type="button"
      role="button"
    >{{ "auto_staking_cancel_btn" | translate }}</button
    >
  </div>
</div>
